import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';
import { logger } from '@/services/fetcher/logger';

import type { TMSSettingsApi } from '../../models';

const masterSettingsApi = fetcher.extend(() => ({
  prefixUrl: `${API.MASTER_SETTINGS}`,
}));

export const saveTmsSettings = async (
  data: TMSSettingsApi,
  { signal }: { signal?: AbortController['signal'] } = {},
): Promise<string> => {
  try {
    return await masterSettingsApi
      .post('SaveTMSSettings', {
        json: data,
        signal,
      })
      .text();
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
